import { FETCH_PENDING_INVENTORY_LIST, FETCH_PENDING_INVENTORY_DETAIL } from "./types";
import * as API from "./api";

// --------------------------------------------------------------------------
// FETCH_PENDING_INVENTORY_LIST
// --------------------------------------------------------------------------
export const fetchPendingInventoryList = (page) => ({
  type: FETCH_PENDING_INVENTORY_LIST.init,
  payload: API.fetchPendingInventoryList(page),
});

export const fetchPendingInventoryListSuccess = (info) => ({
  type: FETCH_PENDING_INVENTORY_LIST.success,
  payload: info,
});

export const fetchPendingInventoryListFailure = (error) => ({
  type: FETCH_PENDING_INVENTORY_LIST.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_PENDING_INVENTORY_DETAIL
// --------------------------------------------------------------------------
export const fetchPendingInventoryDetail = (id) => ({
  type: FETCH_PENDING_INVENTORY_DETAIL.init,
  payload: API.fetchPendingInventoryDetail(id),
});

export const fetchPendingInventoryDetailSuccess = (info) => ({
  type: FETCH_PENDING_INVENTORY_DETAIL.success,
  payload: info,
});

export const fetchPendingInventoryDetailFailure = (error) => ({
  type: FETCH_PENDING_INVENTORY_DETAIL.failure,
  payload: error,
});
